<template>
  <Card id="sale-card" :style="cardStyle">
    <template v-slot:content>
      <div class="grid-container">
        <div class="buyer-name">
          <span class="sale-card-field">
            <span class="material-icons">person</span>
            <p
              class="text-field-overflow"
              v-tooltip.top="sale.buyer?.name || ''"
            >
              {{ sale.buyer?.name || '-' }}
            </p>
          </span>
        </div>
        <div class="date">
          <span class="sale-card-field">
            <span class="material-icons">event</span>
            <p>
              {{ sale.date ? $dayjs(sale.date).format('DD/MM/YYYY') : '-' }}
            </p>
          </span>
        </div>
        <div class="bovine-count">
          <span class="sale-card-field">
            <span><IconBovine style="margin-top: 5px" /></span>
            <p v-if="sale.bovines.length > 1">
              {{ sale.bovines.length }} Bovinos
            </p>
            <p v-else>{{ sale.bovines.length }} Bovino</p>
          </span>
        </div>
        <div class="total-value">
          <span class="sale-card-field">
            <span class="material-icons">attach_money</span>
            <p>{{ $toDecimal(sale.totalValue) }}</p>
          </span>
        </div>
        <div class="buyer-document">
          <span class="sale-card-field">
            <span class="material-icons">assignment</span>
            <p>
              <span v-if="sale.buyer?.document">
                {{
                  sale.buyer?.document.length === 11
                    ? $formatCPF(sale.buyer?.document)
                    : $formatCNPJ(sale.buyer?.document)
                }}
              </span>
              <span v-else> - </span>
            </p>
          </span>
        </div>
        <div class="invoice">
          <span class="sale-card-field">
            <span><IconInvoice style="margin-top: 5px" /></span>
            <p>{{ sale.invoice || '-' }}</p>
          </span>
        </div>
        <div class="bovine-summary">
          <span class="sale-card-field">
            <BovineTypeSummary
              style="margin-top: 5px"
              :bovines="bovines"
              :inactive="sale.statusId === 3"
            ></BovineTypeSummary>
          </span>
        </div>
        <div class="total-weight">
          <span class="sale-card-field">
            <span>
              <IconWeight style="margin-top: 5px" />
            </span>
            <p>
              {{ sale.totalWeight ? $toDecimal(sale.totalWeight) : '-' }}
            </p>
          </span>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import IconWeight from '../../../components/icon/IconWeight.vue';
import IconBovine from '../../../components/icon/IconBovine.vue';
import IconInvoice from '../../../components/icon/IconInvoice.vue';
import BovineTypeSummary from '../../../components/BovineTypeSummary.vue';

export default {
  name: 'SaleCard',
  components: {
    IconBovine,
    IconInvoice,
    BovineTypeSummary,
    IconWeight,
  },
  props: {
    sale: Object,
  },
  computed: {
    isInactive() {
      return this.sale?.statusId === 3;
    },
    cardStyle() {
      if (this.isInactive) {
        return { backgroundColor: 'rgba(229, 229, 229, 0.5)' };
      }
      return {};
    },
    bovines() {
      return this.sale.bovines.map((saleBovine) => saleBovine.bovine);
    },
  },
};
</script>

<style scoped>
#sale-card >>> .p-card-content {
  padding: 0 !important;
}
.sale-card-field span {
  padding-right: 10px;
}
.sale-card-field p {
  display: inline-block;
  vertical-align: top;
  padding-top: 2px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(6, 1fr);
  gap: 0.5em 1em;
  grid-template-areas:
    'buyer-name buyer-name'
    'buyer-document buyer-document'
    'date bovine-count'
    'total-value total-weight'
    'invoice invoice'
    'bovine-summary bovine-summary';
}

@media (min-width: 600px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 0.5em 1em;
    grid-template-areas:
      'buyer-name invoice total-value'
      'buyer-document bovine-count total-weight'
      'date bovine-summary bovine-summary';
  }
}

@media (min-width: 960px) {
  .grid-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 0.5em 1em;
    grid-template-areas:
      'buyer-name date bovine-count total-value'
      'buyer-document invoice bovine-summary total-weight';
  }
}

.buyer-name {
  grid-area: buyer-name;
}

.date {
  grid-area: date;
}

.bovine-count {
  grid-area: bovine-count;
}

.total-value {
  grid-area: total-value;
}

.buyer-document {
  grid-area: buyer-document;
}

.invoice {
  grid-area: invoice;
}

.bovine-summary {
  grid-area: bovine-summary;
}

.total-weight {
  grid-area: total-weight;
}
</style>
